import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationRef, NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class UiNotificationService {

  hideAfter = 1200;

  constructor(private translateService:TranslateService, 
    private notificationService: NotificationService) {}

  public showDefault(message:string): void {
    message = this.translateService.instant(message);
    this.notificationService.show({
      content: message,
      hideAfter: this.hideAfter,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "fade", duration: 400 },
      type: { style: "none", icon: false },
    });
  }


  public showSuccess(message:string, position?: { horizontal: "right" | "left" | "center", vertical: "top" | "bottom" }): void {
    message = this.translateService.instant(message);
    this.notificationService.show({
      content: message,
      hideAfter: this.hideAfter,
      animation: { type: "fade", duration: 400 },
      position: position ?? { horizontal: "right", vertical: "top" },
      type: { style: "success", icon: true }
    });
  }

  public showWarning(message:string): void {
    message = this.translateService.instant(message);
    this.notificationService.show({
      content: message,
      hideAfter: this.hideAfter,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "fade", duration: 400 },
      type: { style: "warning", icon: true },
    });
  }
  public showInfo(message:string): void {
    message = this.translateService.instant(message);
    this.notificationService.show({
      content: message,
      hideAfter: this.hideAfter,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "fade", duration: 400 },
      type: { style: "info", icon: true },
    });
  }

  public showError(error:any): void {

    let message = JSON.stringify(error);

    if(typeof(error) == 'string'){
      message = this.translateService.instant(error);
    }

    this.notificationService.show({
      content: message,
      hideAfter: 5000,
      position: { horizontal: "right", vertical: "bottom" },
      animation: { type: "fade", duration: 400 },
      type: { style: "error", icon: true }
    });
  }
  public showValidationError(message?:string): void {
    message = this.translateService.instant(message ?? 'global.correctData');
    this.notificationService.show({
      content: message,
      hideAfter: this.hideAfter,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "fade", duration: 400 },
      type: { style: "warning", icon: true },
    });

  }

  public showRunningOperation(message:string): NotificationRef {
    message = this.translateService.instant(message);
    return this.notificationService.show({
      content: message,
      position: { horizontal: "center", vertical: "top" },
      animation: { type: "fade",duration: 400 },
      type: { style: "info", icon: true },
    });
  }
}

